import $ from 'jquery';

// Use JavaScript/jQuery to check if the container has children and add a class accordingly
$(document).ready(function() {
	$('.single-intro__table').each(function() {
		if ($(this).children().length > 0) {
			$(this).addClass('has-children');
		}
	});
});

